import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";
import dataUtils from "../../../../../../common/utils/dataUtils";
import ItemStatus from "../../../../../../common/components/item_status";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

type Props = {
  onActionEditar: (idInformacoes: number | null, openState: boolean) => void;
  onActionDeletar: (idInformacoes: number | null, openState: boolean) => void;
};

export const GenerateInformacoesColumnDefinition = ({ onActionEditar, onActionDeletar }: Props): GridColDef[] => {
  return [
    {
      field: "NomeFuncionario",
      headerName: "Responsável",
      flex: 1,
      minWidth: 100,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
    },
    {
      field: "Data",
      filterable: false,
      headerName: "Data",
      minWidth: 100,
      flex: 1,
      sortable: false,
      valueGetter: (value) => {
        return dataUtils.dataFormatada(value ? value : null);
      },
      headerClassName: "usuarios-header",
    },
    {
      field: "DescInformacoes",
      headerName: "Informações",
      flex: 1,
      minWidth: 100,
      sortable: false,
      filterable: false,
      headerClassName: "projeto-header",
    },
    {
      field: "IdInformacoes",
      headerName: "Ações",
      width: 100,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.value, true)}>
            <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
};
